import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export const AuthModuleStore = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
